// import request from './request';
import search from './CAT4MRO/search';
import infGeneral from './Stages/infGeneral';
import inventory from './Stages/inventory';
import description from './Stages/description';
import equipmentAPL from './Stages/equipment-group-APL';
import logs from './Stages/logs';
import analystView from './Stages/analystView';

export default {
  createNewMaterial: {
    cat4mro: {
      ...search,
    },
    infGeneral: {
      ...infGeneral,
    },
    inventory: {
      ...inventory,
    },
    description: {
      ...description,
    },
    equipmentAPL: {
      ...equipmentAPL,
    },
    tabs: {
      infGeneral: 'Información general',
      inventory: 'Inventario',
      description: 'Descripción',
      equipmentAPL: 'Equipo APL',
      attachments: 'Adjuntos',
      similarMaterials: 'Materiales similares',
      suggestedProvider: 'Proveedores sugeridos',
    },
    matReqStatusCondition: "Esta solicitud se encuentra en la etapa de ",
    searchProviders: "Buscar proveedores",
    send: "Enviar",
    approve: "Aprobar",
    reject: "Rechazar",
    cancel: "Cancelar",
    next: "Siguiente",
    previous: "Anterior",
    openInTab: "Abrir en una pestaña aparte",
    tittleCreationSuccess: "ÉXITO",
    creationSuccess: "El material fue creado exitosamente",
    editionSuccess: "El material fue editado exitosamente",
    tittleCreationError: "Error",
    creationError: "Ocurrió un error al crear el material",
    errorTittle: "Error",
    approveError: "Ocurrió un error al aprobar el material",
    rejectError: "Ocurrió un error al rechazar el material",
    uploadError: "Ocurrió un error al subir el archivo",
    editionError: "Ocurrió un error al editar el material",
    sendError: "Ocurrió un error al enviar el material",
    setAttachmentsError: "Error al querer agregar archivos adjuntos a la solicitud",
    uploadFile: "Carga de archivo",
    uploadFileError: "Ocurrió un error al cargar el archivo",
    uploadFileSuccess: "Archivo cargado exitosamente",
    uploadFilesExcedded: "El tamaño de los archivos adjuntos excede el límite permitido (10)",
    deleteFileError: "Ocurrió un error al querer eliminar el archivo",
    deleteFileSuccess: "Archivo eliminado exitosamente",
    alertTittleRemoveFile: "Eliminar archivo",
    alertMessageRemoveFile: "¿Está seguro que desea eliminar el archivo ",
    alertConfirmRemoveFile: "Eliminar",
    alertCancelRemoveFile: "Cancelar",
    messageDeletedFile: "Archivo eliminado",
    cancelationError: "Ocurrió un error al cancelar la solicitud",
    cancelationSuccess: "Solicitud cancelada exitosamente",
    closeFormConfirm: "¿Desea cerrar el formulario?",
    closeFormConfirmTitle: "Precaución",
    closeFormConfirmYes: "Si",
    closeFormConfirmNo: "No",
    logs,
    attachments: {
      maximunSize: "Se permite archivos de máximo 5MB",
      error: "Ocurrió un error al cargar el archivo",
      maximunSizeError: "El tamaño máximo de un archivo adjunto excede el límite permitido (5MB)",
    },
    analystView: {
      ...analystView,
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/cataloger/createNewMaterials/index.js